import { motion } from 'framer-motion'
import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const PlaybackSpeedMenuPanel = styled(motion.div)`
  padding: 2px;
  min-height: max-content;
  width: 100%;

  border-radius: 4px;

  overflow-y: overlay;
  ${customizeVerticalScrollbarThumbMixin(2)}

  display: flex;
  flex-direction: column;
  gap: 2px;
`
